<template>
    <div id="searchApp">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-md-6 col-12">
                        <h1>{{ $t("label.search_application")}}</h1>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/application">{{ $t("label.application")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.search")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <div class="content">
            <div class="container-fluid table-filter-wrapper">
                <TableFilterV2 toggleButton="#btn-filter">
                    <div class="card">
                        <div class="card-header d-flex">
                            <h3>Filter</h3>
                        </div>
                        <div class="card-body">
                            <form>
                                <div class="form-group">
                                    <label for="status">{{$t('label.status')}}</label>
                                    <select v-model="status" class="form-control" id="status">
                                        <option value="all">{{$t('label.all')}}</option>
                                        <option value="pending">{{$t('label.pending')}}</option>
                                        <option value="declined">{{$t('label.declined')}}</option>
                                        <option value="enrouting">{{$t('label.enrouting')}}</option>
                                        <option value="overstay">{{$t('label.overstay')}}</option>
                                        <option value="amendmentDate">{{$t('label.amendment_date')}}</option>
                                        <option value="amendmentOffice">{{$t('label.amendment_office')}}</option>
                                        <option value="destinationApproved">{{$t('label.destination_approved')}}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label for="registration_type">{{$t('label.type')}}</label>
                                    <select v-model="registration_type" class="form-control" id="registration_type">
                                        <option value="IM" selected>{{$t('label.temporary_import')}}</option>
                                        <option value="EX">{{$t('label.temporary_export')}}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label for="registration_year">{{$t('label.register_year')}}</label>
                                    <input
                                        v-model="registration_year"
                                        type="number"
                                        maxlength="4"
                                        minlength="4"
                                        name="registration_year"
                                        id="registration_year"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group filter_datepicker">
                                    <label>{{$t('label.register_date')}}</label>
                                    <datepicker
                                        v-model="registration_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        format="dd/MM/yyyy"
                                        name="registration_date"
                                        id="registration_date"
                                    ></datepicker>
                                </div>
                                <div class="form-group">
                                    <label for="lodgement_office_code">{{$t('label.lodgement_office_code')}}</label>
                                    <input
                                        v-model="lodgement_office_code"
                                        type="text"
                                        name="lodgement_office_code"
                                        id="lodgement_office_code"
                                        class="form-control"
                                    />
                                </div>

                                <div class="form-group filter_datepicker">
                                    <label>{{$t('label.lodgement_office_date')}}</label>
                                    <datepicker
                                        v-model="lodgement_office_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        format="dd/MM/yyyy"
                                        name="lodgement_office_date"
                                        id="lodgement_office_date"
                                    ></datepicker>
                                </div>

                                <div class="form-group">
                                    <label for="destination_office_code">{{$t('label.destination_office_code')}}</label>
                                    <input
                                        v-model="destination_office_code"
                                        type="text"
                                        name="destination_office_code"
                                        id="destination_office_code"
                                        class="form-control"
                                    />
                                </div>

                                <div class="form-group filter_datepicker">
                                    <label>{{$t('label.destination_office_date')}}</label>
                                    <datepicker
                                        v-model="destination_office_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        format="dd/MM/yyyy"
                                        name="destination_office_date"
                                        id="destination_office_date"
                                    ></datepicker>
                                </div>

                                <div class="form-group">
                                    <label for="owner_border_pass">{{$t('label.owner_border_pass')}}</label>
                                    <input
                                        v-model="owner_border_pass"
                                        type="text"
                                        name="owner_border_pass"
                                        id="owner_border_pass"
                                        class="form-control"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="owner_passport">{{$t('label.owner_passport')}}</label>
                                    <input
                                        v-model="owner_passport"
                                        type="text"
                                        name="owner_passport"
                                        id="owner_passport"
                                        class="form-control"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="company_code">{{$t('label.company_code')}}</label>
                                    <input
                                        v-model="company_code"
                                        type="text"
                                        name="company_code"
                                        id="company_code"
                                        class="form-control"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="plate_number">{{$t('label.plate_number')}}</label>
                                    <input
                                        v-model="plate_number"
                                        type="text"
                                        name="plate_number"
                                        id="plate_number"
                                        class="form-control"
                                    />
                                </div>

                                <div class="row my-4">
                                    <div class="col">
                                        <button
                                            @click="getList('filter')"
                                            type="button"
                                            class="btn btn-sm btn-secondary btn-block"
                                        >
                                            <fa :icon="['fas', 'check']"></fa> Submit
                                        </button>
                                    </div>
                                    <div class="col">
                                        <button @click="reset(true)" type="button" class="btn btn-sm btn-default btn-block">
                                            <fa :icon="['fas', 'redo-alt']"></fa> Reset
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </TableFilterV2>
                <div class="row table-content">
                    <div class="col">
                        <div class="card">
                            <div class="card-header d-flex border-0">
                                <form class="form-inline">
                                    <label class="my-1 mr-2 form-check-label" for="limit">Show</label>
                                    <select
                                            id="limit"
                                            name="limit"
                                            class="custom-select custom-select-sm"
                                            @change="getList()"
                                    >
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    <label class="my-1 ml-2 form-check-label" for="limit">entries</label>
                                </form>
                                <div class="nav nav-pills ml-auto">
                                    <form v-on:submit.prevent="getList('search')">
                                        <li class="nav-item input-group input-group-sm" style="width: 200px;">
                                            <input
                                                    v-model="search"
                                                    type="text"
                                                    name="search_box"
                                                    id="search_box"
                                                    class="form-control float-right"
                                                    placeholder="Search office code, type ..."
                                            />
                                            <div class="input-group-append">
                                                <button type="submit" class="btn btn-default">
                                                    <fa class="nav-icon" :icon="['fas', 'search']"></fa>
                                                </button>
                                            </div>
                                        </li>
                                    </form>
                                    <li class="nav-item ml-1">
                                        <button
                                                @click="getList('excel', true)"
                                                title="Export"
                                                class="btn btn-sm btn-default text-success"
                                        >
                                            <fa :icon="['far', 'file-excel']"></fa>
                                        </button>
                                    </li>
                                    <li class="nav-item ml-1">
                                        <button title="Filter" class="btn btn-sm btn-default" id="btn-filter">
                                            <fa :icon="['fas', 'filter']"></fa>
                                        </button>
                                    </li>
                                </div>
                            </div>
                            <!-- /.card-header -->
                            <div class="card-body table-responsive p-1">
                                <table class="table table-striped" v-if="data.data && data.data.length">
                                    <thead>
                                    <tr class="pt-0">
                                        <th>ID</th>
                                        <th>{{$t('label.type')}}</th>
                                        <th>{{$t('label.register_date')}} <OrderBy :order_by="'registration_date'" @orderBy="getOrderBy"/></th>
                                        <th>{{$t('label.register_number')}} <OrderBy :order_by="'registration_number'" @orderBy="getOrderBy"/></th>
                                        <th>{{$t('label.plate_number')}}</th>
                                        <th>{{$t('label.lodgement_office_code')}}</th>
                                        <th>{{$t('label.lodgement_office_date')}}</th>
                                        <th>{{$t('label.destination_office_code')}}</th>
                                        <th>{{$t('label.destination_office_date')}}</th>
                                        <th>{{$t('label.status')}}</th>
                                        <th style="width:100px;">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="(row, index) in data.data">
                                        <tr :key="index">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ row.registration_type }}</td>
                                            <td>{{ row.registration_date }}</td>
                                            <td>{{ row.registration_number }}</td>
                                            <td>{{ row.vehicle | getPlateNumber }}</td>
                                            <td>{{ row.lodgement_office_code }}</td>
                                            <td>{{ row.lodgement_office_date }}</td>
                                            <td>{{ row.destination_office_code }}</td>
                                            <td>{{ row.destination_office_date }}</td>
                                            <td v-html="getStatus(row)"></td>
                                            <td>
                                                <router-link v-if="$hasPermission('tempvehicle.application.view')" :to="{ name: 'ViewApplication', params: { uuid : row.uuid }}" class="mr-1" target="_blank">
                                                  <button type="button" title="Detail" class="btn btn-info btn-xs">
                                                    <fa class="nav-icon" :icon="['fas', 'eye']"></fa>
                                                  </button>
                                                </router-link>
                                                <router-link v-if="$hasPermission('tempvehicle.application.edit') && row.destination === null" :to="{ name: 'EditApplication', params: { uuid : row.uuid }}" class="mr-1" target="_blank">
                                                    <button type="button" title="Edit" class="btn btn-primary btn-xs">
                                                        <fa class="nav-icon" :icon="['fas', 'edit']"></fa>
                                                    </button>
                                                </router-link>
                                                <button v-if="$hasPermission('tempvehicle.application.delete')" @click="deleteApplication(row.uuid)" type="button" title="Destroy" class="btn btn-danger btn-xs">
                                                    <fa class="nav-icon" :icon="['fas', 'trash-alt']"></fa>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>

                                <NoResult v-if="(!data.data || !data.data.length) && !$store.state.loading.status"></NoResult>
                            </div>

                            <!-- /.card-body -->
                            <div class="card-footer clearfix">
                                <div v-if="data.data && data.data.length" class="card-body">
                                    <div class="m-0 float-left">
                                        Showing
                                        <b>1</b> to
                                        <b>{{show}}</b> of
                                        <b>{{ count_data }}</b> entries
                                    </div>
                                    <paginate
                                            class="pagination-sm m-0"
                                            v-model="page"
                                            :page-count="last_page"
                                            :force-page="forcepage"
                                            :page-range="3"
                                            :margin-pages="2"
                                            :click-handler="getList"
                                            :container-class="'pagination float-right'"
                                            :prev-text="'Prev'"
                                            :prev-class="'page-item'"
                                            :next-text="'Next'"
                                            :next-class="'page-item'"
                                            :page-class="'page-item'"
                                            :active-class="'active'"
                                            :prev-link-class="'page-link'"
                                            :next-link-class="'page-link'"
                                            :page-link-class="'page-link'"
                                            ref="company"
                                    ></paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OrderBy from "@/components/OrderBy.vue";
    import TableFilterV2 from "@/components/TableFilterV2.vue";
    import debounce from "debounce";
    import querystring from "qs";
    import NoResult from "@/components/NoResult.vue";
    import axios from "axios";
    export default {
        name: "Search",
        components: {
            TableFilterV2,
            NoResult,
            OrderBy
        },
        provide() {
          return {
            resetIcon: this.setOrderBy,
          };
        },
        filters: {
          getPlateNumber(vehicle){
            if(vehicle && vehicle.plate_number){
              return vehicle.plate_number;
            }
            return "";
          }
        },
        data(){
            return {
                export: 0,
                status: "",
                registration_type: "",
                registration_year: "",
                registration_date: "",
                lodgement_office_code: "",
                lodgement_office_date: "",
                destination_office_code: "",
                destination_office_date: "",
                owner_border_pass: "",
                owner_passport: "",
                company_code: "",
                plate_number: "",

                data: {},
                search: '',
                count_search: 0,
                filterData: [],
                window: {
                    width: 0,
                    height: 0
                },
                page: 1,
                show: 10,
                pageNumber: 1,
                forcepage: 1,
                current_page: 1,
                last_page: 0,
                order_by: "registration_date",
                order_type: "desc",
                //order_type_after_sort:'',
                order_by_array: [],
            }
        },
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
        },
        mounted() {
            this.getList();
        },

        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            /** Deboun */
            debounceInput: debounce(function () {
                this.getList();
            }, 1000),
            /** Get Data **/
            getList: function(filter = 'default', excel = false) {
                this.$store.state.loading.status = true;
                if (filter === "filter") {
                    this.filterData = []
                    this.page = 1;
                    this.search = "";

                    this.filterData["registration_year"] = this.registration_year ? this.registration_year : this.$route.query.registration_year;

                    this.filterData["lodgement_office_code"] = this.lodgement_office_code ? this.lodgement_office_code : this.$route.query.lodgement_office_code;
                    this.filterData["lodgement_office_date"] = this.lodgement_office_date ? this.lodgement_office_date : this.$route.query.lodgement_office_date;

                    this.filterData["destination_office_code"] = this.destination_office_code ? this.destination_office_code : this.$route.query.destination_office_code;
                    this.filterData["destination_office_date"] = this.destination_office_date ? this.destination_office_date : this.$route.query.destination_office_date;

                    this.filterData["owner_border_pass"] = this.owner_border_pass ? this.owner_border_pass : this.$route.query.owner_border_pass;
                    this.filterData["owner_passport"] = this.owner_passport ? this.owner_passport : this.$route.query.owner_passport;
                    this.filterData["company_code"] = this.company_code ? this.company_code : this.$route.query.company_code;
                    this.filterData["plate_number"] = this.plate_number ? this.plate_number : this.$route.query.plate_number;

                } else if (filter === "search") {
                    this.filterData = []
                    this.reset(false);
                    this.page = 1;
                    this.filterData["search"] = this.search ? this.search : this.$route.query.search;

                }else if(this.$route.query.today){
                  this.filterData["today"] = true;
                }

                this.filterData["registration_type"] = this.registration_type ? this.registration_type : this.$route.query.registration_type;
                this.filterData["registration_date"] = this.registration_date ? this.registration_date : this.$route.query.registration_date;

                this.filterData["status"] = this.status ? this.status : this.$route.query.status;
                this.filterData["export"] = this.export ? this.export : this.$route.query.export;

                this.show = document.getElementById("limit").value;
                this.filterData["page"] = this.page ? this.page : this.$route.query.page;
                this.filterData["show"] = this.show ? this.show : this.$route.query.show;
                this.filterData["order_by"]   = this.order_by ? this.order_by : this.$route.query.order_by;
                this.filterData["order_type"] = this.order_type ? this.order_type : this.$route.query.order_type;

                let queryString = querystring.stringify(this.filterData, {
                    arrayFormat: "brackets"
                });

                // Set params to url
                if (Object.keys(this.filterData).length) {
                    const newUrl = window.location.origin + window.location.pathname + "?" + queryString;
                    window.history.pushState({path: newUrl}, "", newUrl);
                }

                if(excel){
                    this.exportExcel(queryString);
                }else{
                    GDCE_Client.requestApi("POST", `backend/applications/search?${queryString}`).then(result => {
                            this.$store.state.loading.status = false;
                            if (result) {
                                this.data = result.data;
                                this.count_data = result.data.total;
                                this.count_search = result.data.length;
                                this.last_page = result.data.last_page;
                                this.current_page = result.data.current_page;
                                //this.order_type_after_sort = result.data.order_type;
                                //this.order_by = result.data.order_by;
                            }
                        },
                        error => {
                            this.$store.state.loading.status = false;
                            this.$swal({
                                type: "error",
                                icon: "error",
                                title: this.$t("error.something_went_wrong"),
                                text: error.message,
                                showConfirmButton: false
                            });
                        });
                }
            },
            deleteApplication : function(uuid){
                this.$swal({
                    title: this.$t('label.confirm_delete'),
                    icon: "warning",
                    buttons: true,
                    dangerMode: true
                }).then(willDelete => {
                    if (willDelete) {
                        let url = "backend/applications/" + uuid;
                        GDCE_Client.requestApi("DELETE", url).then(response => {
                            this.searchApplication(this.pageNumber, null, null);
                        });
                    }
                });
            },
            reset(refresh = false) {
                this.status= "";
                this.registration_type= "";
                this.registration_year= "";
                this.registration_date= "";
                this.lodgement_office_code= "";
                this.lodgement_office_date= "";
                this.destination_office_code= "";
                this.destination_office_date= "";
                this.owner_border_pass= "";
                this.owner_passport= "";
                this.company_code= "";
                this.plate_number= "";
                this.filterData = [];
                if(refresh){
                    this.search = "";
                    this.getList();
                }
            },
            exportExcel(queryString) {
                const request_url = process.env.VUE_APP_BACKEND_API_URL + `/api/backend/applications/export?${queryString}`;
                const token = this.$store.state.auth.token;
                const headers = {"Content-Type": "application/json", Authorization: `${token.token_type} ${token.access_token}`};
                axios({method: "POST", url: request_url, responseType: "blob", headers: headers})
                    .then(response => {
                        this.$store.state.loading.status = false;
                        if (response.status === 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute("download", "Declaration-list.xlsx");
                            document.body.appendChild(link);
                            link.click();
                        }
                    }).catch(()=> {
                    this.$store.state.loading.status = false;
                });
            },
            getStatus(app){
              const type = app.registration_type;
              if(app.destination && app.destination.status === 'Approve'){
                return '<span class="badge bg-success" title="Destination Assessed">'+ (type === "IM" ? 'Exit' : 'Entry') +' Approved</span>';
              }
              if(app.destination && app.destination.status === 'Decline'){
                return '<span class="badge bg-danger" title="Destination Declined">'+ (type === "IM" ? 'Exit' : 'Entry') +' Declined</span>';
              }
              if(app.lodgement && app.lodgement.status === 'Approve'){
                return '<span class="badge bg-success" title="Lodgement Assessed">'+ (type === "IM" ? 'Entry' : 'Exit') +' Approved</span>';
              }
              if(app.lodgement && app.lodgement.status === 'Decline'){
                return '<span class="badge bg-danger" title="Lodgement Declined">'+ (type === "IM" ? 'Entry' : 'Exit') +' Declined</span>';
              }

              return '<span class="badge bg-warning" title="Lodgement not Assessed">Pending</span>';
            },
            getOrderBy(data){
              this.order_by = data.order_by;
              this.order_type = data.order_type;
              this.resetOtherOrderBy(data.order_by);
              this.getList();
            },
            setOrderBy(fn) {
              this.order_by_array.push(fn);
            },
            resetOtherOrderBy(triggeringId){
              this.order_by_array.forEach(fn => fn(triggeringId));
            }
        }
    }
</script>
